<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Items">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openImportModal()"><i class="fa fa-upload"></i><span>Importação</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Item</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="productStatus" style="font-size: 0.8em">Serial</label>
                  <b-form-select id="productStatus"
                    v-model="filters.seriesControl"
                    :plain="true"
                    :options=yesNoDDL>
                  </b-form-select>
              </b-form-group>
            </b-col>


            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <div class="d-flex align-items-center">
                <span class="text-muted">
                  <strong>Total:</strong> {{ items.length }} itens
                  <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
                </span>
                <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
                <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
              </div>
            </b-col>
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(originalValue)="data">
                    {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                </template>

                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>

                <template v-slot:cell(costcenter)="data">
                    {{ data.item.costCenterCode  }}<br>{{ data.item.costCenterName }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(seriesControl)="data">                    
                    <c-switch class="" @change.native="changeSeriesControl(data.item)" color="primary" :checked="data.item.seriesControl" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>


     <b-modal
        v-model="importModal"
        id="import-modal"
        centered
        hide-footer
        title="Importação"
        size="lg"
        >

        <b-nav fill>
            <b-nav-item :active="tabInfo=='I'" @click="tabInfo='I'">Arquivo CSV</b-nav-item>
            <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>
        </b-nav>

        <div v-show="tabInfo == 'I'">
          <b-card>
            <b-form @submit.stop.prevent="onSubmit">

                <div class="d-flex mb-3">
                    <file-drop-area-component v-model="file" accept=".csv" placeholder="Arraste o arquivo CSV aqui ou clique para selecionar" class="w-100"></file-drop-area-component>
                </div>

                <div class="d-flex mb-3">
                    <b-form-checkbox v-model="updateExisting" id="updateExisting">Atualizar produtos existentes</b-form-checkbox>
                </div>
                <div class="mb-3" v-if="!updateExisting">
                    <small class="text-muted"><i class="fa fa-info-circle"></i> Produtos já cadastrados (mesmo código) serão ignorados na importação.</small>
                </div>

                <div v-if="csvPreview.valid !== null" class="mb-3">
                  <b-alert :show="true" :variant="csvPreview.valid ? 'success' : 'danger'">
                    <span v-if="csvPreview.valid"><i class="fa fa-check-circle"></i> Cabeçalho do arquivo validado com sucesso.</span>
                    <span v-else><i class="fa fa-exclamation-triangle"></i> {{ csvPreview.errorMessage }}</span>
                  </b-alert>

                  <div v-if="csvPreview.rows.length > 0" class="table-responsive">
                    <label style="font-size: 0.8em">Primeiras {{ csvPreview.rows.length }} linha(s) do arquivo</label>
                    <table class="table table-sm table-bordered table-striped">
                      <thead>
                        <tr>
                          <th v-for="(col, idx) in csvPreview.headers" :key="idx">{{ col }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, rIdx) in csvPreview.rows" :key="rIdx">
                          <td v-for="(cell, cIdx) in row" :key="cIdx">{{ cell }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <p></p>
                <div class="d-flex mb-3  justify-content-center">
                    <b-button variant="primary" @click="submitFile" :disabled="!file || !csvPreview.valid || importBusy">Importar CSV</b-button>
                </div>

                <div v-show="importBusy">

                  <div class="d-flex mb-3  justify-content-center">
                          <div class="sk-cube-grid text-danger">
                            <div class="sk-cube sk-cube1"></div>
                            <div class="sk-cube sk-cube2"></div>
                            <div class="sk-cube sk-cube3"></div>
                            <div class="sk-cube sk-cube4"></div>
                            <div class="sk-cube sk-cube5"></div>
                            <div class="sk-cube sk-cube6"></div>
                            <div class="sk-cube sk-cube7"></div>
                            <div class="sk-cube sk-cube8"></div>
                            <div class="sk-cube sk-cube9"></div>
                          </div>
                  </div>
                  <div class="d-flex mb-3  justify-content-center">
                    {{ this.importMessage }}
                  </div>
                
                </div>

            </b-form>
          </b-card>
        </div>

        <div v-show="tabInfo == 'H'">
          <b-card>
            
          </b-card>          
        </div>

    </b-modal>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Item"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
        <!--
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Id"
                label-for="id"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>
        -->

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Tipo de produto"
                label-for="productType"
                :label-cols="3"
                :horizontal="true">


                <b-row>
                  <b-col cols="7">
                    <b-form-select id="productType"
                    v-model="selectedItem.typeId"
                    :plain="true"
                    :options="productTypeDDL"
                    value="">
                  </b-form-select>
                  </b-col>

                </b-row>
                
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Código"
                label-for="code"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.code" id="code" type="text" style="text-transform: uppercase" ></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Descrição"
                label-for="description"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.description"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="U/M"
                label-for="unitOfMeasurement"
                :label-cols="3"
                :horizontal="true">


                <b-row>
                  <b-col cols="7">
                    <b-form-select id="unitOfMeasurement"
                    v-model="selectedItem.umId"
                    :plain="true"
                    :options="umDDL"
                    value="">
                  </b-form-select>
                  </b-col>

                </b-row>
                
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>



          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Serial"
                label-for="seriesControl"
                :label-cols="3"
                :horizontal="true">

                <input id="seriesControl" type="checkbox" v-model="selectedItem.seriesControl">
                
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Item</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', seriesControl: false, _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      FileDropAreaComponent
    },
    data: () => {
      return {
        tabInfo: 'I',
        importBusy: false,
        importMessage: 'Importando arquivo. Pode demorar alguns minutos...',
        file: null,
        updateExisting: false,
        importModal: false,

        csvExpectedColumns: ['ORG_CODE', 'ITEM', 'DESCRIPTION', 'UOM', 'ITEM_TYPE', 'USER ITEM TYPE', 'SERIAL'],
        csvPreviewRowCount: 5,
        csvPreview: {
          valid: null,
          errorMessage: '',
          headers: [],
          rows: []
        },

        inventoryProductStatusDDL: [],

        umDDL: [],
        productTypeDDL: [],
        yesNoDDL: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Sim',
            value: 'Y'
          },
          {
            text: 'Não',
            value: 'N'
          }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],

        isBusy: false,
        isLoadingMore: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          key: '',
          status: 0,
          inventoryProductStatusId: 0,
          seriesControl: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'typeName', label: 'Tipo', sortable: true, thStyle: { width: "200px" } },
          {key: 'code', label: 'Código', sortable: true, thStyle: { width: "200px" } },
          {key: 'description', label: 'Descrição', sortable: true },
          {key: 'umCode', label: 'U/M', sortable: true, thStyle: { width: "100px" } },
          {key: 'seriesControl', label: 'Serial', sortable: true, thStyle: { width: "50px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.filteredItems.length },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  (
                    this.$utils.filterString(item.name, this.filters.key)
                    || this.$utils.filterString(item.description, this.filters.key)
                  
                  )
                
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                  && (this.filters.seriesControl==0 || (this.filters.seriesControl == 'Y' ? item.seriesControl : !item.seriesControl))

            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    watch: {
      filteredItems() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      perPage() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      file(newFile) {
        this.readCsvPreview(newFile);
      }
    },
    methods: {

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      changeSeriesControl(item) {
        if(item != null) {
          item.seriesControl = !item.seriesControl;
          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["name"] = postData["code"] // Não apresenta campo NOME DO PRODUTO, apenas CÓDIGO
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/product",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Item',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.typeId == null || this.selectedItem.typeId <= 0)
            msgError.push("Tipo de produto");

        if(this.selectedItem.code.length <= 2)
            msgError.push("Código");

        if(this.selectedItem.description.length <= 2)
            msgError.push("Descrição");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Item',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      resetCsvPreview() {
        this.csvPreview = { valid: null, errorMessage: '', headers: [], rows: [] };
      },

      readCsvPreview(selectedFile) {
        this.resetCsvPreview();

        if(!selectedFile) {
          return;
        }

        var s = this;
        var reader = new FileReader();

        reader.onload = function(e) {
          var text = e.target.result;
          var lines = text.split(/\r\n|\n|\r/).filter(function(l) { return l.trim().length > 0; });

          if(lines.length === 0) {
            s.csvPreview.valid = false;
            s.csvPreview.errorMessage = 'Arquivo vazio.';
            return;
          }

          var headers = lines[0].split(';').map(function(c) { return c.trim(); });
          var normalizedHeaders = headers.map(function(c) { return c.toUpperCase().replace(/_/g, ' '); });
          var expectedRaw = s.csvExpectedColumns;
          var expectedNormalized = expectedRaw.map(function(c) { return c.toUpperCase().replace(/_/g, ' '); });

          s.csvPreview.headers = headers;
          s.csvPreview.rows = lines.slice(1, 1 + s.csvPreviewRowCount).map(function(line) { return line.split(';'); });

          if(normalizedHeaders.length !== expectedNormalized.length) {
            s.csvPreview.valid = false;
            s.csvPreview.errorMessage = 'Número de colunas incorreto. Esperado ' + expectedNormalized.length + ' (' + expectedRaw.join('; ') + '), encontrado ' + normalizedHeaders.length + '.';
            return;
          }

          var mismatches = [];
          expectedNormalized.forEach(function(col, idx) {
            if(normalizedHeaders[idx] !== col) {
              mismatches.push('coluna ' + (idx + 1) + ': esperado "' + expectedRaw[idx] + '", encontrado "' + (headers[idx] || '') + '"');
            }
          });

          if(mismatches.length > 0) {
            s.csvPreview.valid = false;
            s.csvPreview.errorMessage = 'Cabeçalho não corresponde ao formato esperado - ' + mismatches.join('; ') + '.';
          }
          else {
            s.csvPreview.valid = true;
          }
        };

        reader.onerror = function() {
          s.csvPreview.valid = false;
          s.csvPreview.errorMessage = 'Não foi possível ler o arquivo selecionado.';
        };

        reader.readAsText(selectedFile, 'UTF-8');
      },

      async submitFile() {

        if(this.file && this.csvPreview.valid) {
          this.importBusy = true
        
          var s = this
          let formData = new FormData();
          formData.append('file', this.file);
          formData.append('updateExisting', this.updateExisting);
          formData.append('uid', this.$store.state.currentUser.id);
          formData.append('sid', this.$store.state.currentUser.sid);

          await axios.post(
              this.$store.state.ws_url + "/product/csv/meritor", formData
          ).then(function(resp) {
            console.log(resp)
            toast ({
                  type: VueNotifications.types.info,
                  title: 'Importação',
                  message: resp.data.message,
                  timeout: 10000
            })     
            s.closeImportModal()
            s.importBusy = false
          })
          .catch(function (error) {
            console.log(error);

            toast ({
                  type: VueNotifications.types.error,
                  title: 'Importação',
                  message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                  timeout: 5000
            })   

            s.importBusy = false
            
          });
        }
        
       
      },
      closeImportModal() {
        this.importModal = false;
        this.file = null;
        this.updateExisting = false;
        this.resetCsvPreview();
      },
      openImportModal() {
        this.tabInfo = 'I'
        this.file = null;
        this.updateExisting = false;
        this.resetCsvPreview();
        this.importModal = true;
      },
      closeEditModal() {
        this.editModal = false;
        this.importBusy = false
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      async getProductType() {
          
        var s = this;
        var currentUser = this.$store.state.currentUser;

        if(currentUser && currentUser.id) {
          await axios.get(
              this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
            s.productTypeDDL = resp.data.obj;
          }).catch(function(error) {
            console.log(error)
          })
        }
                
          
      },
      async getUnitOfMeasurement() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        if(currentUser && currentUser.id) {
          await axios.get(
              this.$store.state.ws_url + "/unitofmeasurement/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
            s.umDDL = resp.data.obj;
          }).catch(function(error) {
            console.log(error)
          })
        }
    
      },
      async getInventoryProductStatus() {
         
          var s = this;
          var currentUser = this.$store.state.currentUser;

          if(currentUser && currentUser.id) {
            await axios.get(
                this.$store.state.ws_url + "/inventory/product/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
              s.inventoryProductStatusDDL = resp.data.obj;
            }).catch(function(error) {
              console.log(error)
            })
          }
          
      },
      async refreshData() {
          this.isBusy = true;
          this.isLoadingMore = false;

          var s = this;
          var currentUser = this.$store.state.currentUser;
          var page = 1;
          var pageSize = 100;
          var allItems = [];
          var hasMoreData = true;

          while (hasMoreData) {
            var url = this.$store.state.ws_url + "/product?companyId=" + s.filters.companyId + "&key=" + s.filters.key + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
            try {
              var resp = await axios.get(url);

              if (resp.data.obj && resp.data.obj.length > 0) {
                allItems = allItems.concat(resp.data.obj);

                // Atualiza a tabela com os dados carregados até o momento
                s.items = [...allItems];

                // Remove o loading após carregar a primeira página
                if (page === 1) {
                  s.isBusy = false;
                  // Se há mais páginas, mostra o spinner de loading adicional
                  if (resp.data.obj.length === pageSize) {
                    s.isLoadingMore = true;
                  }
                }

                // Se retornou menos itens que o pageSize, não há mais páginas
                if (resp.data.obj.length < pageSize) {
                  hasMoreData = false;
                } else {
                  page++;
                }
              } else {
                // Sem mais dados
                hasMoreData = false;
              }
            } catch (error) {
              hasMoreData = false;
              toast({
                type: VueNotifications.types.error,
                title: 'Item',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
              });
            }
          }

          this.isBusy = false;
          this.isLoadingMore = false;
      },
      changeCompany() {
        this.getProductType();
        this.getUnitOfMeasurement();
        this.getInventoryProductStatus();
        this.refreshData();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId

      this.changeCompany()
    }
  }
  </script>

  <style src="spinkit/scss/spinkit.scss" lang="scss" />

  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>